<template>
  <v-card>
    <div>
      <v-toolbar flat color="white">
        <v-toolbar-title>Visão Geral</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>

      <v-data-table
        :headers="headers"
        :items="desserts"
        hide-actions
        class="elevation-1"
      >
        <template slot="items" slot-scope="props">
          <tr @click="choiceClient(props.item)">
            <td class="text-xs-left text-capitalize">{{ props.item.name }}</td>
            <td>
              <my-sparkline :data="props.item.online_data"></my-sparkline>
            </td>
            <td>
              <up-down :data="props.item.online_data"></up-down>
            </td>
            <td>{{ props.item.total_devices }}</td>
          </tr>
        </template>
        <template slot="no-data">
          <span>Sem clientes para exibir</span>
        </template>
      </v-data-table>
    </div>
  </v-card>
</template>

<script>
import Webservices from "@/Webservices";
import { mapGetters, mapActions, Store } from "vuex";
import store from "@/store";
import MySparkline from "@/components/charts/MySparkline";
import UpDown from "@/components/charts/UpDown";

const ws = new Webservices();

export default {
  name: "Clientes",
  components: { MySparkline, UpDown },
  data: () => ({
    active: "tab-0",

    headers: [
      {
        text: "Nome",
        value: "name",
        width: "40%"
      },
      { text: "Últimas 24h", width: "40%", align: "left", sortable: false },
      { text: "Tendência", width: "10%", sortable: false },
      {
        text: "Total Devices",
        value: "total_devices",
        align: "center",
        sortable: true
      }
    ],
    desserts: []
  }),
  computed: {
    ...mapGetters(["getGroupName", "getGroupId"])
  },

  mounted() {
    /* ws.getClientsCharts(this.getGroupId).then(response => {
      this.desserts = response.data.map(el => ({
        ...el,
        total_devices: el.online_data ? el.online_data[23] : 0
      }));
    }); */
  },

  watch: {},

  created() {},

  methods: {
    ...mapActions(["selectClient"]),
    choiceClient(client) {
      ws.getClientLogo(client.controller_id).then(response => {
        client["logo_Base64"] = response.data.logo_base64;
        this.selectClient(client);
        this.$router.push("/dashboard_adm");
      });
    }
  }
};
</script>

<style scoped>
.arrow_upward {
  margin-top: 12px;
  width: 0px;
  height: 0px;
  border-style: solid;
  border-width: 0 10px 17px 10px;
  border-color: transparent transparent #1eeb2e transparent;
}

.arrow_downward {
  transform: rotate(180deg);
  margin-top: 12px;
  width: 0px;
  height: 0px;
  border-style: solid;
  border-width: 0 10px 17px 10px;
  border-color: transparent transparent #eb1e36 transparent;
}
.capitalize {
  text-transform: capitalize !important;
}
input {
  margin: 0.4rem;
  border: solid thin darkgray;
}

.active-tab {
  background-color: red !important;
}

td.inner {
  padding: 0 5px !important;
  justify-content: center !important;
  padding-top: 2px !important;
  padding-bottom: 2px !important;
  outline-color: blue !important;
}

.inner > * {
  font-size: small;
}
</style>



// WEBPACK FOOTER //
// src/components/OverView.vue